import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProgramPatientsPage } from './program-patients';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  declarations: [
    ProgramPatientsPage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramPatientsPage),
    NgxDatatableModule
  ],
})
export class ProgramPatientsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-patients/program-patients.module.ts